import "angular";
import "angular-resource";
//Controller
import EmailDirectiveModule from "../directive/email/EmailDirective";

import EDeliveryDirective from "./EDeliveryDirective";
import EDeliveryDisplayController from "./EDeliveryDisplayController";
import EDeliveryEditController from "./EDeliveryEditController";
import EDeliveryFactory from "./EDeliveryFactory";
import EDeliveryInlineController from "./EDeliveryInlineController";
//Directive
import EDeliveryInlineDirective from "./EDeliveryInlineDirective";
//Factory
import EDeliveryService from "./EDeliveryService";

var moduleName = "EDeliveryModule";

const EDeliveryModule = angular
    .module(moduleName, ["ngResource", EmailDirectiveModule.name])
    .controller("EDeliveryDisplayController", EDeliveryDisplayController)
    .controller("EDeliveryEditController", EDeliveryEditController)
    .controller("EDeliveryInlineController", EDeliveryInlineController)
    .factory("EDeliveryFactory", EDeliveryFactory)
    .service("EDeliveryService", EDeliveryService)
    .directive("eDelivery", EDeliveryDirective)
    .directive("eDeliveryInline", EDeliveryInlineDirective);
export default EDeliveryModule;
